export const vahanewyearProductS = {
    mainPromoHeadline: "products.product.promotions.vahanewyear.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.vahanewyear.heading.image",
      title: "products.productS.promotions.vahanewyear.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productS.promotions.vahanewyear.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productS.promotions.vahanewyear.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productS.promotions.vahanewyear.footer",
    total: {
      headline: "products.productS.promotions.vahanewyear.total.headline",
      priceBefore: "products.productS.promotions.vahanewyear.total.priceBefore",
      priceAfter: "products.productS.promotions.vahanewyear.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.vahanewyear.discount.heading",
      title: "products.productS.promotions.vahanewyear.discount.title",
      amount: "products.productS.promotions.vahanewyear.discount.amount",
      code: {
        description:
          "products.productS.promotions.vahanewyear.discount.code.description",
        promoCode:
          "products.productS.promotions.vahanewyear.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.vahanewyear.items.item1.title",
        description:
          "products.productS.promotions.vahanewyear.items.item1.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.vahanewyear.items.item2.title",
        description:
          "products.productS.promotions.vahanewyear.items.item2.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.vahanewyear.items.item3.title",
        description:
          "products.productS.promotions.vahanewyear.items.item3.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.vahanewyear.items.item4.title",
        description:
          "products.productS.promotions.vahanewyear.items.item4.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.vahanewyear.items.item5.title",
        description:
          "products.productS.promotions.vahanewyear.items.item5.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item5.priceAfter",
      },
      item6: {
        title: "products.productS.promotions.vahanewyear.items.item6.title",
        description:
          "products.productS.promotions.vahanewyear.items.item6.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item6.priceAfter",
      },
      item7: {
        title: "products.productS.promotions.vahanewyear.items.item7.title",
        description:
          "products.productS.promotions.vahanewyear.items.item7.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item7.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item7.priceAfter",
      },
      item8: {
        title: "products.productS.promotions.vahanewyear.items.item8.title",
        description:
          "products.productS.promotions.vahanewyear.items.item8.description",
        priceBefore:
          "products.productS.promotions.vahanewyear.items.item8.priceBefore",
        priceAfter:
          "products.productS.promotions.vahanewyear.items.item8.priceAfter",
      },
    },
  };
  
  export const flatrateVahanewyearProductS = {
    mainPromoHeadline:
      "products.productS.promotions.flatrateVahanewyear.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.flatrateVahanewyear.heading.image",
      title: "products.productS.promotions.flatrateVahanewyear.heading.title",
    },
    footer: "products.productS.promotions.flatrateVahanewyear.footer",
    total: {
      headline: "products.productS.promotions.flatrateVahanewyear.total.headline",
      priceBefore:
        "products.productS.promotions.flatrateVahanewyear.total.priceBefore",
      priceAfter:
        "products.productS.promotions.flatrateVahanewyear.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.vahanewyear.discount.heading",
      title: "products.productS.promotions.flatrateVahanewyear.discount.title",
      amount: "products.productS.promotions.flatrateVahanewyear.discount.amount",
      code: {
        description:
          "products.productS.promotions.flatrateVahanewyear.discount.code.description",
        promoCode:
          "products.productS.promotions.flatrateVahanewyear.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item1.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item1.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item2.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item2.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item3.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item3.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item4.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item4.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item5.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item5.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item5.priceAfter",
      },
      item6: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item6.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item6.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item6.priceAfter",
      },
      item7: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item7.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item7.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item7.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item7.priceAfter",
      },
      item8: {
        title: "products.productS.promotions.flatrateVahanewyear.items.item8.title",
        description:
          "products.productS.promotions.flatrateVahanewyear.items.item8.description",
        priceBefore:
          "products.productS.promotions.flatrateVahanewyear.items.item8.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahanewyear.items.item8.priceAfter",
      },
    },
  };
  
  export const vahanewyearProductX = {
    mainPromoHeadline: "products.productX.promotions.vahanewyear.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.vahanewyear.heading.image",
      title: "products.productX.promotions.vahanewyear.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productX.promotions.vahanewyear.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productX.promotions.vahanewyear.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productX.promotions.vahanewyear.footer",
    total: {
      headline: "products.productX.promotions.vahanewyear.total.headline",
      priceBefore: "products.productX.promotions.vahanewyear.total.priceBefore",
      priceAfter: "products.productX.promotions.vahanewyear.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.vahanewyear.discount.heading",
      title: "products.productX.promotions.vahanewyear.discount.title",
      amount: "products.productX.promotions.vahanewyear.discount.amount",
      code: {
        description:
          "products.productX.promotions.vahanewyear.discount.code.description",
        promoCode:
          "products.productX.promotions.vahanewyear.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.vahanewyear.items.item1.title",
        description:
          "products.productX.promotions.vahanewyear.items.item1.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.vahanewyear.items.item2.title",
        description:
          "products.productX.promotions.vahanewyear.items.item2.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.vahanewyear.items.item3.title",
        description:
          "products.productX.promotions.vahanewyear.items.item3.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.vahanewyear.items.item4.title",
        description:
          "products.productX.promotions.vahanewyear.items.item4.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.vahanewyear.items.item5.title",
        description:
          "products.productX.promotions.vahanewyear.items.item5.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item5.priceAfter",
      },
      item6: {
        title: "products.productX.promotions.vahanewyear.items.item6.title",
        description:
          "products.productX.promotions.vahanewyear.items.item6.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item6.priceAfter",
      },
      item7: {
        title: "products.productX.promotions.vahanewyear.items.item7.title",
        description:
          "products.productX.promotions.vahanewyear.items.item7.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item7.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item7.priceAfter",
      },
      item8: {
        title: "products.productX.promotions.vahanewyear.items.item8.title",
        description:
          "products.productX.promotions.vahanewyear.items.item8.description",
        priceBefore:
          "products.productX.promotions.vahanewyear.items.item8.priceBefore",
        priceAfter:
          "products.productX.promotions.vahanewyear.items.item8.priceAfter",
      },
    },
  };
  
  export const flatrateVahanewyearProductX = {
    mainPromoHeadline:
      "products.productX.promotions.flatrateVahanewyear.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.flatrateVahanewyear.heading.image",
      title: "products.productX.promotions.flatrateVahanewyear.heading.title",
    },
    footer: "products.productX.promotions.flatrateVahanewyear.footer",
    total: {
      headline: "products.productX.promotions.flatrateVahanewyear.total.headline",
      priceBefore:
        "products.productX.promotions.flatrateVahanewyear.total.priceBefore",
      priceAfter:
        "products.productX.promotions.flatrateVahanewyear.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.vahanewyear.discount.heading",
      title: "products.productX.promotions.flatrateVahanewyear.discount.title",
      amount: "products.productX.promotions.flatrateVahanewyear.discount.amount",
      code: {
        description:
          "products.productX.promotions.flatrateVahanewyear.discount.code.description",
        promoCode:
          "products.productX.promotions.flatrateVahanewyear.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item1.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item1.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item2.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item2.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item3.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item3.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item4.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item4.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item5.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item5.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item5.priceAfter",
      },
      item6: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item6.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item6.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item6.priceAfter",
      },
      item7: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item7.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item7.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item7.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item7.priceAfter",
      },
      item8: {
        title: "products.productX.promotions.flatrateVahanewyear.items.item8.title",
        description:
          "products.productX.promotions.flatrateVahanewyear.items.item8.description",
        priceBefore:
          "products.productX.promotions.flatrateVahanewyear.items.item8.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahanewyear.items.item8.priceAfter",
      },
    },
  };
  